import { CloseOutlined, PlusOutlined } from "@ant-design/icons"
import { Form, FormInstance, FormProps, Input, Modal, Select } from "antd"
import { ChangeEvent, useEffect, useRef, useState } from "react"
import './style.scss'
import { URL_CAR_CATEGORY } from "../../../../../env"
import { useForm } from "antd/lib/form/Form"
import { ISelectOption } from "../../../../../api/selectOptions/selectOptionsApi"
import { getCLCarLines, getCLCategoryCar, getCLTypeVehicle, getCLVehicle, getCLVehicleGroup } from "../../../../../api/selectOption/selectOptionsApi"
import { fommatSelectOption } from "../../../../../until"
import { editVehicleModels, IVehicleModel } from "../../../../../api/carModel/carModelApi"
import { CARTYPE } from "../../../../../services/data"
interface ModalProps {
  isOpen: boolean
  infoVehicleModel?: IVehicleModel
  onSubmitFormModal?: (iSsuccess: boolean, errorMessage?: string) => void;
  closeModal: () => void
}
const ModalEdit: React.FC<ModalProps> = ({
  isOpen, infoVehicleModel,
  onSubmitFormModal, closeModal
}) => {

  const { CAR_BUS, CAR } = CARTYPE
  const inputRef = useRef<FormInstance>(null);
  const [form] = useForm();
  const isProgrammaticCarLineSet = useRef(false);
  const isProgrammaticTypeVehicleSet = useRef(false);
  const isProgrammaticGroupVehicleSet = useRef(false);
  const isProgrammaticCategorySet = useRef(false);

  const idCarlines = Form.useWatch("idCarlines", form);
  const idTypeVehicle = Form.useWatch("idTypeVehicle", form);
  const idGroupVehicle = Form.useWatch("idGroupVehicle", form);
  const idProductVehicle = Form.useWatch("idProductVehicle", form);
  const idCategoryCar = Form.useWatch("idCategoryCar", form);

  const [cLCarLines, setCLCarLines] = useState<ISelectOption[]>([])
  const [cLTypeVehicle, setCLTypeVehicle] = useState<ISelectOption[]>([])
  const [cLCategoryCar, setCLCategoryCar] = useState<ISelectOption[]>([])
  const [cLVehicleGroup, setCLVehicleGroup] = useState<ISelectOption[]>([])
  const [cLVehicle, setCLVehicle] = useState<ISelectOption[]>([])

  const gCLCarLines = async () => {
    const result = await getCLCarLines()
    if (result?.status) {
      setCLCarLines(fommatSelectOption(result.data))
    }
  }

  const gCLTypeVehicle = async () => {
    if (!idCarlines) return
    const result = await getCLTypeVehicle(idCarlines)
    if (result?.status) {
      setCLTypeVehicle(fommatSelectOption(result.data))
    }
  }

  const gCLVehicleGroup = async () => {
    if (!idCategoryCar) return
    if (idCarlines !== CAR_BUS) return
    const result = await getCLVehicleGroup(
      idCarlines, idCategoryCar
    )
    if (result?.status) {
      setCLVehicleGroup(fommatSelectOption(result.data))
    }
  }

  const gCLCategoryCar = async () => {
    if (idCarlines === CAR_BUS) {
      const result = await getCLCategoryCar(
        idCarlines, undefined
      )
      if (result?.status) {
        setCLCategoryCar(fommatSelectOption(result.data))
      }
    } else {
      if (!idTypeVehicle) return
      const result = await getCLCategoryCar(
        idCarlines, idTypeVehicle
      )
      if (result?.status) {
        setCLCategoryCar(fommatSelectOption(result.data))
      }
    }
  }

  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };

  const onFinish: FormProps["onFinish"] = async (values) => {
    if (!infoVehicleModel?.id) return
    const {
      code, title, idCarlines, idTypeVehicle,
      idGroupVehicle, idProductVehicle, idCategoryCar
    } = values
    const result = await editVehicleModels(
      infoVehicleModel.id, title, code,
      idCarlines, idTypeVehicle, idCategoryCar,
      idGroupVehicle, idProductVehicle
    )
    if (result?.status) {
      onSubmitFormModal?.(true, result?.message)
    } else {
      onSubmitFormModal?.(false, result?.message)
    }
  }

  useEffect(() => {
    if (idCarlines === CAR) {
      gCLTypeVehicle()
    }
    if (isProgrammaticCarLineSet.current) {
      isProgrammaticCarLineSet.current = false;
      return;
    }
    if (isOpen) {
      form.setFieldValue("idTypeVehicle", undefined);
    }
  }, [idCarlines]);

  useEffect(() => {
    if (idCarlines === CAR_BUS) gCLCategoryCar()
    if (isProgrammaticCategorySet.current) {
      isProgrammaticCategorySet.current = false;
      return;
    }
    if (isOpen) {
      form.setFieldValue("idCategoryCar", undefined);
      form.setFieldValue("idGroupVehicle", undefined);

    }

  }, [idCarlines]);

  useEffect(() => {
    if (idTypeVehicle) {
      if (idCarlines !== CAR_BUS)
        gCLCategoryCar()
    }

    if (isProgrammaticTypeVehicleSet.current) {
      isProgrammaticTypeVehicleSet.current = false;
      return;
    }
    if (isOpen) {
      form.setFieldValue("idGroupVehicle", undefined);
      form.setFieldValue("idProductVehicle", undefined);
      form.setFieldValue("idCategoryCar", undefined);
    }
  }, [idTypeVehicle]);


  useEffect(() => {
    if (idCarlines === CAR_BUS && idCategoryCar)
      gCLVehicleGroup()
    if (isProgrammaticGroupVehicleSet.current) {
      isProgrammaticGroupVehicleSet.current = false;
      return;
    }

  }, [idCategoryCar]);




  useEffect(() => {
    if (isOpen) {
      if (!cLCarLines.length)
        gCLCarLines()

      if (infoVehicleModel) {
        isProgrammaticCarLineSet.current = true;
        isProgrammaticTypeVehicleSet.current = true;
        isProgrammaticGroupVehicleSet.current = true;
        isProgrammaticCategorySet.current = true;

        const {
          carLineId, typeVehicleId, groupVehicleId, productVehicleId, categoryCarId, code, title
        } = infoVehicleModel

        form.setFieldsValue({
          idCarlines: carLineId,
          idTypeVehicle: typeVehicleId,
          idGroupVehicle: groupVehicleId,
          idProductVehicle: productVehicleId,
          idCategoryCar: categoryCarId,
          code: code,
          title: title,
        });
      }

    } else {
      isProgrammaticCarLineSet.current = false;
      isProgrammaticTypeVehicleSet.current = false;
      isProgrammaticGroupVehicleSet.current = false;
      isProgrammaticCategorySet.current = false;

      form.resetFields()
    }

  }, [isOpen])
  return (
    <Form
      form={form}
      ref={inputRef}
      onFinish={onFinish}
      initialValues={{ remember: true }}
    >
      <Modal
        title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
          <span className="text-base text-344054 fw-500 font-medium">Chỉnh sửa mẫu xe</span>
          <CloseOutlined className="text-base text-8B8B8B" onClick={closeModal} />
        </div>}
        open={isOpen}
        onCancel={closeModal}
        centered
        className="w-modal modal-content ant-modal-size"
        closeIcon={false}
        footer={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-2 px-6 w-full border-t-F0F0F0">
          <span className="text-sm text-98A2B3 cursor-pointer" onClick={closeModal}>Huỷ</span>
          <button className="text-white text-sm bg-096DD9 border-none shadow-btn-save rounded-2 h-8 px-15-px"
            onClick={submitForm}>
            Lưu
          </button>
        </div>}
      >
        <div className="px-6 py-2 d-flex flex-column gap-2">
          <div className="d-flex gap-2 flex-column pt-2">
            <div className="d-flex flex-column gap-1">

              <Form.Item
                label={<span className="">Dòng xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                className="m-none-form-item text-explan text-label"
                name="idCarlines"
                rules={[{ required: true, message: 'Chọn dòng xe!' }]}
              >
                <Select
                  allowClear
                  options={cLCarLines}
                />
              </Form.Item>
            </div>
            {
              idCarlines === CAR &&
              <div className="d-flex flex-column gap-1">

                <Form.Item
                  label={<span className="">Loại xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                  layout="vertical"
                  className="m-none-form-item text-explan text-label"
                  name="idTypeVehicle"
                  rules={[{ required: true, message: 'Chọn loại xe!' }]}
                >
                  <Select
                    // disabled={!idCarlines}
                    allowClear
                    options={cLTypeVehicle}
                  />
                </Form.Item>
              </div>
            }

            <div className="d-flex flex-column gap-1">

              <Form.Item
                label={<span className="">Thương hiệu xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                className="m-none-form-item text-explan text-label"
                name="idCategoryCar"
                rules={[{ required: true, message: 'Chọn Thương hiệu xe!' }]}
              >
                <Select
                  disabled={idCarlines !== CAR_BUS ? !idTypeVehicle : false}
                  allowClear
                  options={cLCategoryCar}
                />
              </Form.Item>
            </div>
            {
              idCarlines === CAR_BUS && (
                <>
                  <div
                    className={`d-flex flex-column gap-1 `}
                  >
                    <Form.Item
                      label={<span className="">Nhóm sản phẩm<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                      layout="vertical"
                      name="idGroupVehicle"
                      className="m-none-form-item text-explan text-label"
                      rules={[{ required: true, message: 'Chọn nhóm sản phẩm!' }]}
                    >
                      <Select
                        disabled={!idCategoryCar}
                        allowClear
                        options={cLVehicleGroup}
                      />
                    </Form.Item>
                  </div>
                  {/* <div className={`d-flex flex-column gap-1 `}>
                    <Form.Item
                      label={<span className="">Sản phẩm<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                      layout="vertical"
                      name="idProductVehicle"
                      className="m-none-form-item text-explan text-label"
                      rules={[{ required: true, message: 'Chọn sản phẩm!' }]}
                    >
                      <Select
                        disabled={!idGroupVehicle}
                        allowClear
                        options={cLVehicle}
                      />
                    </Form.Item>
                  </div> */}
                </>
              )
            }
          </div>
          <div className="d-flex flex-column gap-1">
            <div className="d-flex flex-column gap-1">
              <Form.Item
                label={<span className="">Mã mẫu xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="code"
                rules={[{ required: true, message: 'Nhập mã mẫu xe!' }]}
                className="m-none-form-item text-explan text-label"
              >
                <Input
                  placeholder="Mã mẫu xe"
                  className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                />
              </Form.Item>
            </div>
          </div>
          <div className="d-flex flex-column gap-1 pt-2">
            <div className="d-flex flex-column gap-4">
              <Form.Item
                label={<span className="">Tên mẫu xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="title"
                rules={[{ required: true, message: 'Nhập tên mẫu xe!' }]}
                className="m-none-form-item text-explan text-label"
              >
                <Input
                  placeholder="Tên mẫu xe"
                  className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                />
              </Form.Item>
            </div>
          </div>



        </div>
      </Modal>
    </Form>

  )
}
export default ModalEdit
